import { Link } from "react-router-dom";
import type { Work } from "@/types";
import { typeLabel } from "@/utils/work";

interface HotRankingProps {
  works: Work[];
}

export default function HotRanking({ works }: HotRankingProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
          <i className="ri-fire-fill text-lg" />
        </span>
        <div>
          <h3 className="font-heading text-base font-bold text-foreground-950">
            热门影视榜
          </h3>
          <p className="text-xs text-foreground-500">按站内热度实时排序 TOP 10</p>
        </div>
      </div>

      <ul className="flex flex-col divide-y divide-background-200">
        {works.map((work, index) => {
          const rank = index + 1;
          return (
            <li key={work.id}>
              <Link
                to={`/detail/${work.id}`}
                className="group flex items-center gap-3 py-3"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                    rank <= 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {rank}
                </span>
                <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={work.poster}
                    alt={`${work.title} 封面`}
                    title={`${work.title} - 国产自拍热榜`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-accent-600">
                    {work.title}
                  </p>
                  <p className="mt-1 flex items-center gap-1.5 text-xs text-foreground-500">
                    <span>{typeLabel(work.type)}</span>
                    <span className="text-foreground-300">·</span>
                    <span>{work.year}</span>
                  </p>
                </div>
                <span className="flex shrink-0 items-center gap-1 text-xs font-bold text-secondary-700">
                  <i className="ri-star-fill text-[11px]" />
                  {work.rating.toFixed(1)}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}